export const FDC_TEST_CODE = {
    pH: 'pH',    
    Conductivity: 'Cond',
    Cyanide: 'ClCk',
    FreeChlorine: 'C2FO',
    TotalChlorine: 'Cl2O',
    AmpFreeChlorine: 'Cl2A',
    Temperature: 'Temp',
    DissolvedFilter: 'DMFW', 
    DissolvedOxy: 'DO', 
    FieldFilteration: 'FFil',
    HexCrField: 'S2Ck',    
    Flow: 'Flow',
    FlowRate: 'floa',
}

export const VERIFICATION_REQ_TEST_CODES = [
    FDC_TEST_CODE.pH,
    FDC_TEST_CODE.Conductivity,
    FDC_TEST_CODE.Cyanide,
    FDC_TEST_CODE.FreeChlorine,
    FDC_TEST_CODE.TotalChlorine,
    FDC_TEST_CODE.Temperature,
    FDC_TEST_CODE.DissolvedFilter,
    FDC_TEST_CODE.DissolvedOxy,
    FDC_TEST_CODE.FieldFilteration,
    FDC_TEST_CODE.HexCrField,
]

export const EQUIP_TYPES = {
    pHMeter: 'pH Meter',
    pHProbe: 'pH Probe',
    pHMeterWithProbe: 'pH Meter with Probe',
    thermometer: 'Thermometer',
    chlorine: 'Chlorine Colorimeter',
    conductivity: 'Conductivity Meter', 
    dissolvedOxy: 'Dissolved Oxygen Meter'
}

export const CHEMICAL_TYPES = {
    pH2: "pH 2 Calibration Fluid",
    pH4: "pH 4 Calibration Fluid",
    pH6: "pH 6 Calibration Fluid",
    pH7: "pH 7 Calibration Fluid",
    pH8: "pH 8 Calibration Fluid",
    pH10: "pH 10 Calibration Fluid",
    pH12: "pH 12 Calibration Fluid",
    lvc: "pH LCS/ICV",
    chlorineFree: 'Chlorine Pillow Packets - Free',
    chlorineTotal: 'Chlorine Pillow Packets - Total',
    NaOH: 'Sodium Hydroxide (NaOH)',
}

export const CHEMICAL_KEYS = Object.fromEntries(
  Object.entries(CHEMICAL_TYPES).map(([k, v]) => [v, k])
);

export const SUPPLY_TYPES = {
    chlorineStrips: 'Chlorine Test Strips',
    sulfateStrips: 'Sulfate Test Strips',
    pHStrip_0_14: 'pH Test Strips -  0-14',
    pHStrips_8_10: 'pH Test Strips -  8.2-9.8',
    Pipettes: 'Pipettes',
    Syringes: 'Syringes',
    Filters: 'Filters'
}

export const FDC_EQUIP_TYPE_MAP = {
    [FDC_TEST_CODE.pH]: [
        EQUIP_TYPES.pHMeter,
        EQUIP_TYPES.pHProbe,
        EQUIP_TYPES.pHMeterWithProbe
    ],
    [FDC_TEST_CODE.Conductivity]: [ EQUIP_TYPES.conductivity ],
    [FDC_TEST_CODE.FreeChlorine]: [ EQUIP_TYPES.chlorine ],
    [FDC_TEST_CODE.TotalChlorine]: [ EQUIP_TYPES.chlorine ],
    [FDC_TEST_CODE.DissolvedOxy]: [ EQUIP_TYPES.dissolvedOxy ],
    [FDC_TEST_CODE.Temperature]: [ EQUIP_TYPES.thermometer ],
}

export const FDC_CHEM_TYPE_MAP = {
    [FDC_TEST_CODE.pH]: [
        CHEMICAL_TYPES.pH2,
        CHEMICAL_TYPES.pH4,
        CHEMICAL_TYPES.pH6,
        CHEMICAL_TYPES.pH7,
        CHEMICAL_TYPES.pH8,
        CHEMICAL_TYPES.pH10,
        CHEMICAL_TYPES.pH12,
        CHEMICAL_TYPES.lvc,
    ],
    [FDC_TEST_CODE.FreeChlorine]: [ CHEMICAL_TYPES.chlorineFree ],
    [FDC_TEST_CODE.TotalChlorine]: [ CHEMICAL_TYPES.chlorineTotal ],
    [FDC_TEST_CODE.HexCrField]: [ CHEMICAL_TYPES.NaOH ],
}

export const REQUIRED_pH_CHEMICALS = [CHEMICAL_TYPES.pH4, CHEMICAL_TYPES.pH7, CHEMICAL_TYPES.pH10, CHEMICAL_TYPES.lvc] 

export const FDC_SUPPLY_TYPE_MAP = {
    [FDC_TEST_CODE.Cyanide]: [
        SUPPLY_TYPES.chlorineStrips,
        SUPPLY_TYPES.sulfateStrips
    ],
    [FDC_TEST_CODE.DissolvedFilter]: [
        SUPPLY_TYPES.Syringes,
        SUPPLY_TYPES.Filters
    ],
    [FDC_TEST_CODE.FieldFilteration]: [
        SUPPLY_TYPES.Syringes,
        SUPPLY_TYPES.Filters
    ],
    [FDC_TEST_CODE.HexCrField]: [
        SUPPLY_TYPES.Pipettes,
        SUPPLY_TYPES.pHStrip_0_14,
        SUPPLY_TYPES.pHStrips_8_10,
    ]
}

export const FIELD_ITEMS_ENTITY_TYPE = {
    EQUIPMENT: "EQUIPMENT",
    SUPPLY_LOG: "SUPPLY",
    CHEMICAL_LOG: "CHEMICAL"
}

export const CALIBATION_STEPS = {
    VERIFY: "VERIFICATION",
    CALIBRATE: 'CALIBRATION'
}

export const FDC_TEST_TYPES = {
    STANDARD: 'standard',
    DUPLICATE: 'duplicate'
}

export const NO_BOTTLE_REQ_ID = 106
